import { CellRange, DataMap } from '@mescius/wijmo.grid';
import { AutoComplete } from '@mescius/wijmo.input';
import { CellMaker } from "@mescius/wijmo.grid.cellmaker";
import {
  math,
  formatBigNumber,
  formatEmission25Number,
  validateNumberFieldBySetting,
  $_helper_isNumberType_bySetting,
  formatNumberBySetting,
} from '../wijmo.helper'

import store from '@/store';
import debounce from 'lodash/debounce'
import i18n from '@/lang/i18n.js';

import { toolTipCustom } from "@/utils/tooltipCustom";
import { getWidthByTextContent } from '@/utils/calcTextWidth';
import { validateMaximumCharactorOnlyFacility } from '@/utils/validate';
import { getListDbAddNew, getDbAddNewInObject } from '@/concerns/utils/master-or-customize-db'
import { getWidthOfAttachedButton, getWidthButtonByText } from '@/utils/multiLanguage';
import { handlerFilterData, handlerAddFilterData, getColumnIndexByBinding, getBranchId } from '@/concerns/utils/filter-data'
import { KEYS_CODE } from '@/constants/keyboard'
import { BLANK_ID, MESSAGE_NOT_NULL } from '@/constants/registerData';
import { CURRENCY_TYPE, GROUP_COMPANY_KEY } from '@/constants/registerData';
import {
  handlerFilterGroupBusinessData,
  handlerAddGroupBusinessFilterData
} from '@/concerns/utils/business-groups';
import { formatNumberRealNum, addThoundSandCommaWithTwoDigit } from '@/utils/convertNumber';
import { getScoreByType } from '@/concerns/utils/pcaf-data';

export const blankData = (clientRowId) => {
  return {
    clientRowId: clientRowId,
    id: BLANK_ID,
    organizational_division: null,
    business_name: null,
    company_name: null,
    ides_name_company: null,
    ie_scope: null,
    ie_ghg_emissions: null,
    ie_year: null,
    il_amount: null,
    il_total_amount: null,
    emissions: null,
    attribution_factor: null,
    duration_id: null,
    month: null,
    year: null,
    type: null,
    memo_1: null,
    memo_2: null,
    country: null,
    layer_3: null,
    layer_4: null,
    layer_5: null,
    layer_6: null,
    category_1: null,
    loan_amount: null,
    currency: null,
    category_2: null,
    value_purchase: null,
    score: null,
    db_relation: null,
    fuel_type: null,
    basic_unit_name: null,
    fuel_intensity: null,
    fuel_consumption: null,
    total_distance_driven: null,
    fuel_efficiency: null,
    amount_of_fuel_consumed: null,
    vehicle_type: null,
  }
}

const calcEmissions = (data) => {
  const {
    loan_amount,
    value_purchase,
    fuel_intensity,
    amount_of_fuel_consumed,
    isLimitedAttributionFactor = false,
  } = data;
  const arrayKeyToCalcEmissions = ['loan_amount', 'value_purchase', 'fuel_intensity', 'amount_of_fuel_consumed'];

  const isAllItemIsNumber = arrayKeyToCalcEmissions.every((key) => $_helper_isNumberType_bySetting(data[key])); // check number all value
  if (isAllItemIsNumber) {

    const val_amount = math.bignumber(formatNumberBySetting(loan_amount));
    const val_purchase = math.bignumber(formatNumberBySetting(value_purchase));
    const val_amount_of_fuel_consumed = math.bignumber(formatNumberBySetting(amount_of_fuel_consumed));
    const val_fuel_intensity = math.bignumber(formatNumberBySetting(fuel_intensity));


    const emissionVal = formatBigNumber(
      math.evaluate(
        `(${val_amount.toString()} / ${val_purchase.toString()}  * ${val_fuel_intensity.toString()} * ${val_amount_of_fuel_consumed.toString()} ) `,
      ),
      25,
    );

    if (isLimitedAttributionFactor) {
      const isOnlyAmountSmallerZero = math.smaller(val_amount, '0') && !math.smaller(val_purchase, '0');
      const isOnlyTotalCapitalSmallerZero = !math.smaller(val_amount, '0') && math.smaller(val_purchase, '0');
      const isAmountAndTotalCapitalSmallerZero = math.smaller(val_amount, '0') && math.smaller(val_purchase, '0');
      const isAttributionSmallerZeroPercent = isOnlyAmountSmallerZero || isOnlyTotalCapitalSmallerZero;
      const isHasZeroVal = math.isZero(val_purchase) || math.isZero(val_amount);
      const isAttributionLarger100Percent =
        math.larger(val_amount, val_purchase) ||
        (isAmountAndTotalCapitalSmallerZero && math.smaller(val_amount, val_purchase));

      if (isAttributionSmallerZeroPercent || isHasZeroVal) {
        return '0.00';
      } else if (isAttributionLarger100Percent) {
        return formatBigNumber(
          math.evaluate(`${val_fuel_intensity.toString()} * ${val_amount_of_fuel_consumed.toString()}`),
          25,
        );
      } else {
        return emissionVal;
      }
    } else {
      return math.isZero(val_purchase) ? '0.00' : emissionVal;
    }
  }
  return '0.00';
};

const calcAmountOfFuelConsumed = (data) => {
  const { total_distance_driven, fuel_consumption } = data;

  const arrayKeyToCalcAmountOfFuelConsumed = ['total_distance_driven', 'fuel_consumption']
  const isAllItemIsNumber = arrayKeyToCalcAmountOfFuelConsumed.every(key => $_helper_isNumberType_bySetting(data[key])) // check number all value

  if (isAllItemIsNumber) {
    const val_total_distance_driven = math.bignumber(formatNumberBySetting(total_distance_driven));
    const val_fuel_consumption = math.bignumber(formatNumberBySetting(fuel_consumption));
    const amountOfFuelConsumedVal = formatBigNumber(math.evaluate(`${val_total_distance_driven.toString()}  * ${val_fuel_consumption.toString()}`),25)
    return amountOfFuelConsumedVal;
  }
  return '0.00';
}
let notNullList = [
  'organizational_division',
  'company_name',
  'loan_amount',
  'currency',
  'value_purchase',
  'fuel_type',
  'basic_unit_name',
  'fuel_intensity',
  'total_distance_driven',
  'car_model_identifier',
  'fuel_efficiency',
  'fuel_consumption',
  'amount_of_fuel_consumed',
  'vehicle_type',
]

const notNullListIncludeValueNumber2 = [
  'organizational_division',
  'company_name',
  'loan_amount',
  'currency',
  'value_purchase',
  'fuel_type',
  'basic_unit_name',
  'fuel_intensity',
  'total_distance_driven',
  'fuel_efficiency',
  'car_model_identifier',
  'fuel_consumption',
  'amount_of_fuel_consumed',
  'vehicle_type',
]

const max25Charactor = [
  'value_purchase',
  'loan_amount',
]

const max128Charactor = [
  'memo_1',
  'memo_2',
  'category_1',
  'category_2',
]

const numberField = [
  'value_purchase',
  'loan_amount',
]
const plusWidthMark = 70;
let isReverted = false;
let isBusinessGroupReverted = false;
const filterColumns = ['organizational_division', 'company_name', 'business_name', 'country', 'layer_3', 'layer_4', 'layer_5', 'layer_6']

const handleAutoFillDefaultValue = dataBinding => {
  // const { currentItem, isDeleteTing } = dataBinding
  const { s, binding, cellData, currentItem, isLimitedAttributionFactor, isDeleteTing } = dataBinding
  const totalDistanceDrivenVal = formatNumberBySetting(currentItem['total_distance_driven'])
  const amountOfFuelConsumed = formatNumberBySetting(currentItem['amount_of_fuel_consumed'])


  if (!isDeleteTing) {
    if (!currentItem?.currency) {
      currentItem['currency'] = CURRENCY_TYPE[0];
    }
    if (!currentItem?.dq_quality_score || currentItem?.dq_quality_score !== 2) {  //case copy paste
      currentItem['dq_quality_score'] = 2; //default value
    }
  }
  if (!totalDistanceDrivenVal || isNaN(totalDistanceDrivenVal) || totalDistanceDrivenVal < 1) {
    currentItem['total_distance_driven'] = null;
  }
  if (!amountOfFuelConsumed || isNaN(amountOfFuelConsumed) || amountOfFuelConsumed < 0) {
    currentItem['amount_of_fuel_consumed'] = null;
  }

}

const autoBindingDbSource = async (dataBinding) => {
  const { s, binding, cellData, currentItem, isLimitedAttributionFactor, dbStore } = dataBinding
  handleAutoFillDefaultValue(dataBinding)

  if (['loan_amount', 'value_purchase', 'amount_of_fuel_consumed', 'fuel_intensity'].includes(binding)) {
    s.deferUpdate(() => {
      const dataForCalcEmissions = {
        loan_amount: currentItem.loan_amount,
        value_purchase: currentItem.value_purchase,
        amount_of_fuel_consumed: currentItem.amount_of_fuel_consumed,
        fuel_intensity: currentItem.fuel_intensity,
        isLimitedAttributionFactor,
      }
      currentItem['emissions'] = calcEmissions(dataForCalcEmissions);
    })
  }

  if (['basic_unit_name'].includes(binding)) {
    if (currentItem.basic_unit_name) {
      const itemsSource = dbStore.basicUnitFuelList
      const fuelIntensity = itemsSource.filter(item => item.fuel_intensity === currentItem.basic_unit_name || item.basic_unit_name === currentItem.basic_unit_name)[0]?.fuel_intensity
      s.deferUpdate(() => {
        currentItem['fuel_intensity'] = formatNumberRealNum(fuelIntensity);
      })
    } else {
      s.deferUpdate(() => {
        currentItem['fuel_intensity'] = null;
      })
    }
  }
  if (['total_distance_driven', 'fuel_consumption'].includes(binding)) {
    s.deferUpdate(() => {
      const dataForCalcAmountOfFuelConsumed = {
        total_distance_driven: currentItem.total_distance_driven,
        fuel_consumption: currentItem.fuel_consumption,
      }
      currentItem['amount_of_fuel_consumed'] = formatNumberRealNum(calcAmountOfFuelConsumed(dataForCalcAmountOfFuelConsumed));
    })
  }
  if (['vehicle_type'].includes(binding)) {
    if (currentItem['vehicle_type'] === null ) {
      s.deferUpdate(() => {
        currentItem['search_modal'] = null;
        currentItem['car_model_identifier'] = null;
        currentItem['fuel_efficiency'] = null;
        currentItem['fuel_consumption'] = null;
        currentItem['total_distance_driven'] = null;
        currentItem['amount_of_fuel_consumed'] = null;
      });
    }
  }
}

let filterIndex = {};
const parternS3c15pcaf6 = {
  initializeGrid(dataProps) {
    const {
      flexgrid,
      itemCount,
      branchData = {},
      businessGroupList,
      isLimitedAttributionFactor,
      isRemoveEmissionFactorOrValNumber,
      typeOfPattern,
      getNewBbStore,
      handleDataOnCheckError,
    } = dataProps

    let selectedFirst = null;
    let previousCellData = null;
    let filterBusinessGroupIndex = {};
    let selectedBusinessGroupFirst = null;
    let previousBusinessGroupCellData = null;
    const dbStore = getNewBbStore()

    flexgrid.scrollPositionChanged.addHandler(debounce((s, e) => {
      if (!store.state.registerData.isFullScreen) {
        return
      }

      if (s.viewRange.bottomRow >= s.rows.length - 1) {
        s.deferUpdate(() => {
          const lastClientId = flexgrid.itemsSource.itemCount

          for (let index = 1; index <= itemCount; index++) {
            s.itemsSource.addNew(blankData(lastClientId + index));
          }

          s.itemsSource.commitNew();
          s.itemsSource.clearChanges();
        });
      }
    }, 100))

    document.addEventListener('keydown', (e) => {
      if (
        (e.metaKey || e.ctrlKey) &&
        [KEYS_CODE.DOWN_ARROW, KEYS_CODE.UP_ARROW, KEYS_CODE.LEFT_ARROW, KEYS_CODE.RIGHT_ARROW, KEYS_CODE.ENTER].includes(e.keyCode)
      ) {
        e.preventDefault();
      }
    });

    flexgrid.hostElement.addEventListener('keydown', (e) => {
      if (e.metaKey || e.ctrlKey) {
        if (e.keyCode === KEYS_CODE.DOWN_ARROW) {
          const currentSelection = flexgrid.selection
          const cellRange = new CellRange(flexgrid.rows.length - 1, currentSelection.col)
          flexgrid.selection = cellRange

          // re-select after add more
          setTimeout(() => {
            flexgrid.selection = cellRange
          }, 200);
        } else if (e.keyCode === KEYS_CODE.UP_ARROW) {
          const currentSelection = flexgrid.selection
          const cellRange = new CellRange(0, currentSelection.col)
          flexgrid.selection = cellRange
        } else if (e.keyCode === KEYS_CODE.RIGHT_ARROW) {
          const currentSelection = flexgrid.selection
          const cellRange = new CellRange(currentSelection.row, flexgrid.columns.length - 1)
          flexgrid.selection = cellRange
        } else if (e.keyCode === KEYS_CODE.LEFT_ARROW) {
          const currentSelection = flexgrid.selection
          const cellRange = new CellRange(currentSelection.row, 1)
          flexgrid.selection = cellRange
        }
      }
      if (e.keyCode === KEYS_CODE.ENTER) {
        if (flexgrid.selection.row === flexgrid.rows.length - 1) {
          const lastClientId = flexgrid.itemsSource.itemCount

          flexgrid.deferUpdate(() => {
            flexgrid.itemsSource.addNew(blankData(lastClientId + 1));

            flexgrid.itemsSource.commitNew();
            // flexgrid.itemsSource.clearChanges();
          });
        }
      }

    }, false)

    flexgrid.cellEditEnded.addHandler((s, e) => {
      let column = s.columns[e.col];
      const binding = column.binding

      const { row, col } = e.range
      const dbStore = getNewBbStore()
      const dataStore = dbStore.getDbCustomizeOrDbMasterById
      const isDeleteTing = e.data && (e.data.key === 'Backspace' || e.data.key === 'Delete')
      const dbAddNewInObject = getDbAddNewInObject(getListDbAddNew(dbStore.dbExternalAdded))
      if (filterColumns.includes(binding)) {
        handlerFilterData(s, e, branchData?.filterPatternList, filterIndex, selectedFirst, previousCellData, isReverted);
      } else if (GROUP_COMPANY_KEY.includes(binding)) {
        handlerFilterGroupBusinessData({ s, e }, businessGroupList['item'], filterBusinessGroupIndex, selectedBusinessGroupFirst, previousBusinessGroupCellData, isBusinessGroupReverted)
      }
      const { cellData, currentItem, clientRowId } = handleDataOnCheckError({ s, rowIndex: row, colIndex: col, colBinding: binding });

      if (binding === 'fuel_type') {
        const indexSource = s.columns.findIndex(item => item.binding === 'fuel_type')
        const itemsSource = s.columns[indexSource].editor.itemsSource;
        if (!currentItem._selectedFirst && cellData && e.data !== cellData && itemsSource.length > 1) {
          currentItem._selectedFirst = binding
        }
        // handle basic_unit_name itemSource base on fuel_type
        if (currentItem.basic_unit_name) {
          const itemsSource = dbStore.basicUnitFuelList
          const basicUnitFuelCode = itemsSource.filter(item => item.fuel_intensity === currentItem.basic_unit_name || item.basic_unit_name === currentItem.basic_unit_name)[0]?.fuel_code

          const itemsFuelTypeSource = dbStore.fuelList
          const fuelTypeCode = itemsFuelTypeSource.filter(item => item.fuel_code === currentItem.fuel_type || item.fuel_code === parseInt(currentItem.fuel_type) || item.fuel_type === currentItem.fuel_type)[0]?.fuel_code

          if (parseInt(fuelTypeCode) && parseInt(fuelTypeCode) !== basicUnitFuelCode) {
            s.deferUpdate(() => {
              currentItem['basic_unit_name'] = null;
              currentItem['fuel_intensity'] = null;
            })
          }
        }
        // handle vehicle_type base on fuel_type
        if (currentItem.vehicle_type) {
          const itemsFuelTypeSource = dbStore.fuelList
          const fuelTypeCode = itemsFuelTypeSource.filter(item => item.fuel_code === currentItem.fuel_type || item.fuel_code === parseInt(currentItem.fuel_type) || item.fuel_type === currentItem.fuel_type)[0]?.fuel_code

          const itemsSource = dbStore.vehicleTypeList.filter(item => item.fuel_code === parseInt(fuelTypeCode) || item.fuel_code === fuelTypeCode)
          const vehicleTypeFuelCode = itemsSource.filter(item => item.id === currentItem.vehicle_type || item.id === parseInt(currentItem.vehicle_type) || item.vehicle_type === currentItem.vehicle_type)[0]?.fuel_code

          if (parseInt(currentItem.fuel_type) && vehicleTypeFuelCode !== fuelTypeCode) {
            s.deferUpdate(() => {
              currentItem['vehicle_type'] = null;
            })
          }
        }
      }

      if (binding === 'basic_unit_name') {
        if (!currentItem._selectedFirst && cellData && e.data !== cellData) {
          currentItem._selectedFirst = binding
        }
        // handle fuel_type itemSource base on basic_unit_name
        if (currentItem.fuel_type) {
          const itemsBasicUnitSource = dbStore.basicUnitFuelList
          const basicUnitFuelCode = itemsBasicUnitSource.filter(item => item.fuel_intensity === currentItem.basic_unit_name || item.basic_unit_name === currentItem.basic_unit_name)[0]?.fuel_code

          const itemsFuelTypeSource = dbStore.fuelList
          const fuelTypeCode = itemsFuelTypeSource.filter(item => item.fuel_code === currentItem.fuel_type || item.fuel_code === parseInt(currentItem.fuel_type) || item.fuel_type === currentItem.fuel_type)[0]?.fuel_code

          if (basicUnitFuelCode && parseInt(fuelTypeCode) !== basicUnitFuelCode) {
            s.deferUpdate(() => {
              currentItem['fuel_type'] = null;
            })
          }
        }
        // handle vehicle_type base on vehicle_type
        if (currentItem.vehicle_type) {
          const itemsBasicUnitSource = dbStore.basicUnitFuelList
          const basicUnitFuelCode = itemsBasicUnitSource.filter(item => item.fuel_intensity === currentItem.basic_unit_name || item.basic_unit_name === currentItem.basic_unit_name)[0]?.fuel_code

          const itemsSource = dbStore.vehicleTypeList.filter(item => item.fuel_code === parseInt(basicUnitFuelCode) || item.fuel_code === basicUnitFuelCode)
          const vehicleTypeFuelCode = itemsSource.filter(item => item.id === currentItem.vehicle_type || item.id === parseInt(currentItem.vehicle_type) || item.vehicle_type === currentItem.vehicle_type)[0]?.fuel_code

          if (basicUnitFuelCode && vehicleTypeFuelCode && vehicleTypeFuelCode !== basicUnitFuelCode) {
            s.deferUpdate(() => {
              currentItem['vehicle_type'] = null;
            })
          }
        }
      }

      if (binding === 'vehicle_type') {
        if (!currentItem._selectedFirst && cellData && e.data !== cellData) {
          currentItem._selectedFirst = binding
        }
        // handle basic_unit_name itemSource base on vehicle_type
        if (currentItem.basic_unit_name) {
          const itemsSource = dbStore.basicUnitFuelList
          const itemsVehicleSource = dbStore.vehicleTypeList

          const basicUnitFuelCode = itemsSource.find(item => item.fuel_intensity === currentItem.basic_unit_name || item.basic_unit_name === currentItem.basic_unit_name)?.fuel_code
          const vehicleTypeFuelCode = itemsVehicleSource.find(item => item.vehicle_type === currentItem.vehicle_type)?.fuel_code

          if (vehicleTypeFuelCode && basicUnitFuelCode && (basicUnitFuelCode !== vehicleTypeFuelCode || basicUnitFuelCode !== vehicleTypeFuelCode)) {
            s.deferUpdate(() => {
              currentItem['basic_unit_name'] = null;
              currentItem['fuel_intensity'] = null;
            })
          }
        }
        // handle fuel_type itemSource base on vehicle_type
        if (currentItem.fuel_type) {
          const itemsSource = dbStore.vehicleTypeList
          const vehicleTypeFuelCode = itemsSource.find(item => item.vehicle_type === currentItem.vehicle_type)?.fuel_code

          const itemsFuelTypeSource = dbStore.fuelList
          const fuelTypeCode = itemsFuelTypeSource.find(item => item.fuel_code === currentItem.fuel_type || item.fuel_code === parseInt(currentItem.fuel_type) || item.fuel_type === currentItem.fuel_type)?.fuel_code

          if (vehicleTypeFuelCode && vehicleTypeFuelCode !== parseInt(fuelTypeCode)) {
            s.deferUpdate(() => {
              currentItem['fuel_type'] = null;
            })
          }
        }
      }

      const dataBinding = { s, binding, row: clientRowId, cellData, currentItem, dataStore, dbStore, isLimitedAttributionFactor, isRemoveEmissionFactorOrValNumber, typeOfPattern, isCellEditEnd: true, isDeleteTing, dbStore, dbAddNewInObject }
      autoBindingDbSource(dataBinding)
    });

    flexgrid.beginningEdit.addHandler((s, e) => {
      let column = s.columns[e.col];

      if (['emissions', 'car_model_identifier'].includes(column.binding)) {
        e.cancel = true;
      }

      const { row, col } = e.range
      const cellData = s.getCellData(row, col, false)
      const view = s.collectionView;
      const source = view.items;
      const currentItem = source[row] || {};
      const dbStore = getNewBbStore()

      if (filterColumns.includes(column.binding)) {
        previousCellData = cellData;
        handlerAddFilterData(s, e, filterIndex, selectedFirst, store.state.registerData, branchData);
      }

      if (GROUP_COMPANY_KEY.includes(column.binding)) {
        previousBusinessGroupCellData = cellData;
        handlerAddGroupBusinessFilterData({ s, e }, businessGroupList['item'], filterBusinessGroupIndex, selectedBusinessGroupFirst)
      }

      // handle basic_unit_name itemSource base on fuel_type
      if (column.binding === 'basic_unit_name') {
        const indexSource = s.columns.findIndex(item => item.binding === 'basic_unit_name')
        const defaultList = dbStore.basicUnitFuelList
        if (!currentItem.fuel_type && !currentItem.vehicle_type) {
          s.columns[indexSource].editor.itemsSource = defaultList
        } else {
          const typeFuelSelect = currentItem.fuel_type
          const typeVehicleSelect = currentItem.vehicle_type
          const fuelTypeList = dbStore.fuelList
          const vehicleTypeList = dbStore.vehicleTypeList

          // find fuel_code by fuel_type
          const fuelTypeCode = fuelTypeList.find(item => item.fuel_code === typeFuelSelect || item.fuel_code === parseInt(typeFuelSelect) || item.fuel_type === typeFuelSelect)?.fuel_code
          // find fuel_code by vehicle_type
          const vehicleTypeSelect = vehicleTypeList.find(item => item.vehicle_type === typeVehicleSelect)?.fuel_code
  
          const listByFilter = typeFuelSelect 
            ? defaultList.filter(item => item.fuel_code === parseInt(fuelTypeCode) || item.fuel_code === fuelTypeCode)
            : defaultList.filter(item => item.fuel_code === parseInt(vehicleTypeSelect) || item.fuel_code === vehicleTypeSelect)

          if ((typeFuelSelect || typeVehicleSelect) && currentItem._selectedFirst && currentItem._selectedFirst !== 'basic_unit_name') {
            s.columns[indexSource].editor.itemsSource = listByFilter
          } else {
            s.columns[indexSource].editor.itemsSource = defaultList
          }
        }
        if (!currentItem._selectedFirst) currentItem._selectedFirst = 'basic_unit_name';
      };

      // handle fuel_type itemSource base on basic_unit_name
      if (column.binding === 'fuel_type') {
        const indexSource = s.columns.findIndex(item => item.binding === 'fuel_type')
        const defaultList = dbStore.fuelList
        if (!currentItem.basic_unit_name && !currentItem.vehicle_type) {
          s.columns[indexSource].editor.itemsSource = defaultList
        } else {
          const typeBasicUnitSelect = currentItem.basic_unit_name
          const typeVehicleSelect = currentItem.vehicle_type
          const basicUnitList = dbStore.basicUnitFuelList
          const vehicleTypeList = dbStore.vehicleTypeList
  
          // find fuel_code by fuel_intensity
          const basicUnitSelect = basicUnitList.find(item => item.fuel_intensity === typeBasicUnitSelect || item.basic_unit_name === typeBasicUnitSelect)?.fuel_code
          // find fuel_code by vehicle_type
          const vehicleTypeSelect = vehicleTypeList.find(item => item.vehicle_type === typeVehicleSelect)?.fuel_code
  
          const listByFilter = typeBasicUnitSelect 
            ? defaultList.filter(item => item.fuel_code === parseInt(basicUnitSelect) || item.fuel_code === basicUnitSelect)
            : defaultList.filter(item => item.fuel_code === parseInt(vehicleTypeSelect) || item.fuel_code === vehicleTypeSelect)

          if ((typeBasicUnitSelect || typeVehicleSelect) && currentItem._selectedFirst && currentItem._selectedFirst !== 'fuel_type') {
            s.columns[indexSource].editor.itemsSource = listByFilter
          } else {
            s.columns[indexSource].editor.itemsSource = defaultList
          }
        }
        if (!currentItem._selectedFirst) currentItem._selectedFirst = 'fuel_type';
      }

      // handle vehicle_type itemSource base on fuel_type
      if (column.binding === 'vehicle_type') {
        const indexSource = s.columns.findIndex(item => item.binding === 'vehicle_type')
        const defaultList = dbStore.vehicleTypeList
        if (!currentItem.fuel_type && !currentItem.basic_unit_name) {
          s.columns[indexSource].editor.itemsSource = defaultList
        } else {
          const typeFuelSelect = currentItem.fuel_type
          const typeBasicUnitSelect = currentItem.basic_unit_name
          const basicUnitList = dbStore.basicUnitFuelList
          const fuelTypeList = dbStore.fuelList
          
          // find fuel_code by basic_unit_name
          const basicUnitSelect = basicUnitList.find(item => item.fuel_intensity === typeBasicUnitSelect || item.basic_unit_name === typeBasicUnitSelect)?.fuel_code
          // find fuel_code by fuel_type
          const fuelTypeCode = fuelTypeList.find(item => item.fuel_code === typeFuelSelect || item.fuel_code === parseInt(typeFuelSelect) || item.fuel_type === typeFuelSelect)?.fuel_code
          
          const listByFilter = typeFuelSelect
            ? defaultList.filter(item => item.fuel_code === parseInt(fuelTypeCode) || item.fuel_code === fuelTypeCode)
            : defaultList.filter(item => item.fuel_code === parseInt(basicUnitSelect) || item.fuel_code === basicUnitSelect)

          if ((typeFuelSelect || typeBasicUnitSelect) && currentItem._selectedFirst && currentItem._selectedFirst !== 'vehicle_type') {
            s.columns[indexSource].editor.itemsSource = listByFilter
          } else {
            s.columns[indexSource].editor.itemsSource = defaultList
          }
          if (!currentItem._selectedFirst) currentItem._selectedFirst = 'vehicle_type';
        }
      };

      if (!currentItem.fuel_type && !currentItem.basic_unit_name && !currentItem.vehicle_type) {
        currentItem._selectedFirst = null //reset first select
      }
    });

    flexgrid?.formatItem.addHandler((s, e) => {
      const colBinding = e.panel.columns[e.col].binding;

      if (e.panel === s.columnHeaders) {

        if (colBinding === "loan_amount" && e.cell.innerText?.split('\n')[1] === i18n.t('56_pattern.table_amount')) {
          toolTipCustom(
            e,
            "t4",
            i18n.t('56_pattern.tooltip_loan_amount'),  //todo: update text
            dbStore.hdrTips
          );
        }
        
      }
    });
  },

  header(dataProps) {
    const { registerData, listLayout, branchData, attachFilePopup, typeOfPattern, searchModalCarLoan, basicUnitFuelList, fuelList, vehicleTypeList } = dataProps;
    
    let companyMap = new DataMap(branchData.company_name, 'value', 'value');
    companyMap.getDisplayValues = (dataItem) => {
      let validCompany = branchData?.company_name?.filter(
        (company) => company.organizational_division === dataItem?.organizational_division,
      );
      return validCompany.map((item) => {
        return {
          value: item.value,
        };
      });
    };

    companyMap.getDisplay = (dataItem) => {
      let validCompany = branchData?.company_name?.filter(
        (company) => company.organizational_division === dataItem,
      );
      return validCompany.map((item) => {
        return {
          value: item.value,
        };
      });
    };

    let businessMap = new DataMap(branchData.business_name, 'value', 'value');
    businessMap.getDisplayValues = (dataItem) => {
      let validBusiness = branchData?.business_name?.filter(
        (company) => company.company_name === dataItem?.company_name,
      );

      let uniqueItem = [...new Map(validBusiness.map((item) => [item['name'], item])).values()];
      return uniqueItem.map((item) => {
        return {
          value: item.value,
          key: item.value,
        };
      });
    };

    businessMap.getDisplay = (dataItem, organizational_division) => {
      let validBusiness = branchData?.business_name?.filter(
        (business) => business.company_name === dataItem && business.organizational_division === organizational_division,
      );

      let uniqueItem = [...new Map(validBusiness.map((item) => [item['name'], item])).values()];
      return uniqueItem.map((item) => {
        return {
          value: item.value,
          key: item.value,
        };
      });
    };

    const current_emissions_type = typeOfPattern.itemsDataType.findIndex(item => item.id === typeOfPattern.dataTypeIdSelect);
    let name_emissions_type_col = '';
    let name_acreage_col = '';
    let name_emission_col = ''

    if (current_emissions_type >= 0) {
      const item_select = typeOfPattern.itemsDataType[current_emissions_type]

      name_emissions_type_col = [16, 17].includes(item_select?.id) ? i18n.t('pcaf_update.estimated_travel_distance') : item_select?.name;

      name_emission_col = [12, 13].includes(item_select?.id) ? i18n.t('pcaf_update.emission_factors_by_fuel') : i18n.t('pcaf_update.emission_factors_by_fuel_co2');
      if (item_select?.id > 12 && item_select?.id <= 15) {
        name_acreage_col = i18n.t('pcaf_update.fuel_consumption_by_vehicle_model')
      } else if (item_select?.id === 16) {
        name_acreage_col = i18n.t('pcaf_update.fuel_consumption_by_vehicle_type')
      } else if (item_select?.id === 17) {
        name_acreage_col = i18n.t('pcaf_update.average_vehicle_fuel_economy')
      }
    }

    return [
      {
        header: '連番',
        binding: 'id', // id
        minWidth: 40,
        maxWidth: 65,
        allowSorting: false,
        isReadOnly: true,
        visible: false,
        isRequired: false,
      },
      {
        header: i18n.t('56_pattern.table_organizational_division'),
        binding: 'organizational_division', // phan loai to chuc
        minWidth: 96,
        maxWidth: 980,
        allowResizing: true,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        cssClassAll: 'required-field',
        dataMap: new DataMap(registerData.listType, 'key', 'value'),
        editor: new AutoComplete(document.createElement('div'), {
          placeholder: i18n.t('56_pattern.placeholder'),
          itemsSource: registerData.listType,
          selectedValuePath: 'key',
          displayMemberPath: 'value',
          maxItems: 1000,
          minLength: 1,
          selectedIndex: -1,
        }),
      },
      {
        header: i18n.t('56_pattern.table_company_name'),
        binding: 'company_name',
        minWidth: 85,
        maxWidth: 980,
        allowSorting: false,
        isRequired: false,
        wordWrap: true,
        cssClassAll: 'required-field',
        dataMap: companyMap,
        editor: new AutoComplete(document.createElement('div'), {
          placeholder: i18n.t('56_pattern.placeholder'),
          itemsSource: branchData?.company_name,
          selectedValuePath: 'value',
          displayMemberPath: 'value',
          maxItems: 1000,
          minLength: 1,
          selectedIndex: -1,
        }),
      },
      ...listLayout,
      {
        header: i18n.t('56_pattern.table_memo_1'),
        binding: 'memo_1',
        minWidth: 90,
        maxWidth: 980,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        multiLine: true
      },
      {
        header: i18n.t('56_pattern.table_memo_2'),
        binding: 'memo_2',
        minWidth: 90,
        maxWidth: 980,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        multiLine: true
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.table_emission_intensity'),
        align: 'center',
        columns: [
          {
            header: i18n.t('table_pcaf_vehicle_loan.table_fuel_type'),
            binding: 'fuel_type', // fuel type
            minWidth: 90,
            maxWidth: 980,
            allowResizing: true,
            allowSorting: false,
            wordWrap: true,
            isRequired: false,
            cssClassAll: 'required-field',
            dataMap: new DataMap(fuelList, 'fuel_code', 'fuel_type'),
            editor: new AutoComplete(document.createElement('div'), {
              placeholder: i18n.t('56_pattern.placeholder'),
              itemsSource: fuelList,
              selectedValuePath: 'fuel_code',
              displayMemberPath: 'fuel_type',
              maxItems: 1000,
              minLength: 1,
              selectedIndex: -1,
            }),
          },
          {
            header: i18n.t('table_pcaf_vehicle_loan.table_basic_unit_name'),
            binding: 'basic_unit_name', // basic unit
            minWidth: 70,
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            multiLine: true,
            dataMap: new DataMap(basicUnitFuelList, 'fuel_intensity', 'basic_unit_name'),
            editor: new AutoComplete(document.createElement('div'), {
              placeholder: i18n.t('56_pattern.placeholder'),
              itemsSource: basicUnitFuelList,
              selectedValuePath: 'fuel_intensity',
              displayMemberPath: 'basic_unit_name',
              maxItems: 1000,
              minLength: 1,
              selectedIndex: -1,
            }),
          },
          {
            header: i18n.t('table_pcaf_vehicle_loan.table_basic_unit_fuel'),
            binding: 'fuel_intensity', // fuel intensity
            minWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.table_basic_unit_fuel')),
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            inputType: 'float',
            dataType: 'Number',
            isReadOnly: true,
            align: 'right',
          },
        ],
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.table_vehicle_type'),
        binding: 'vehicle_type', // vehicle type
        width: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.table_vehicle_type'), 40),
        maxWidth: 980,
        allowResizing: true,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        cssClassAll: 'required-field',
        dataMap: new DataMap(vehicleTypeList, 'vehicle_type', 'vehicle_type'),
        editor: new AutoComplete(document.createElement('div'), {
          placeholder: i18n.t('56_pattern.placeholder'),
          itemsSource: vehicleTypeList,
          selectedValuePath: 'vehicle_type',
          displayMemberPath: 'vehicle_type',
          maxItems: 1000,
          minLength: 1,
          selectedIndex: -1,
        }),
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.label_search_model'),
        binding: "search_modal",
        isRequired: false,
        allowSorting: false,
        maxWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.label_search_model')) + 40,
        minWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.label_search_model')),
        wordWrap: true,
        cssClassAll: 'search-detail custom-cell-width hide-filter',
        cellTemplate: CellMaker.makeButton({
          text: `<div class="vehicle-search-text">
              ${i18n.t('table_pcaf_vehicle_loan.label_vehicle_type')}
            </div>`,
          click: (e, ctx) => searchModalCarLoan(ctx) //todo: edit with modal
        }),
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.label_fuel_cost'),
        align: 'center',
        columns: [
          {
            header: i18n.t('table_pcaf_vehicle_loan.label_name_modal_category'),
            binding: 'car_model_identifier',
            minWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.label_name_modal_category')),
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            cssClass: 'auto-increment',
            cssClassAll: 'required-field',
          },
          {
            header: i18n.t('table_pcaf_vehicle_loan.label_fuel_cost_unit'),
            binding: 'fuel_efficiency',
            minWidth: 160,
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            isReadOnly: true,
            align: 'right',
          },
          {
            header: i18n.t('table_pcaf_vehicle_loan.label_fuel_consumption'),
            binding: 'fuel_consumption',
            minWidth: 160,
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            inputType: 'float',
            dataType: 'Number',
            isReadOnly: true,
            align: 'right',
          },
        ],
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.total_distance_driven'), //total_distance_driven
        binding: 'total_distance_driven',
        minWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.total_distance_driven'), 4),
        maxWidth: 980,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        multiLine: true,
        inputType: 'float',
        dataType: 'Number',
        cssClassAll: 'required-field',
        align: 'right',
      },
      {
        header: i18n.t('table_pcaf_vehicle_loan.amount_of_fuel_consumed'), // amount_of_fuel_consumed
        binding: 'amount_of_fuel_consumed',
        minWidth: getWidthByTextContent(i18n.t('table_pcaf_vehicle_loan.amount_of_fuel_consumed')),
        maxWidth: 980,
        allowSorting: false,
        wordWrap: true,
        isRequired: false,
        multiLine: true,
        inputType: 'float',
        dataType: 'Number',
        isReadOnly: true,
        align: 'right',
      },
      {
        header: i18n.t('56_pattern.table_attribution_factor'), //Attribution factor
        align: 'center',
        columns: [
          {
            header: i18n.t('56_pattern.table_category1'), // hạng mục
            binding: 'category_1',
            minWidth: 160,
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
          },
          {
            header: i18n.t('56_pattern.table_amount'), // số tiền cho vay 
            binding: 'loan_amount',
            width: getWidthButtonByText(i18n.t('56_pattern.table_amount'), { fontSize: '13px', fontWeight: 500, letterSpacing: '0.04em', lineHeight: 20 }) + plusWidthMark,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            align: 'right',
            cssClassAll: 'required-field',
          },
          {
            header: i18n.t('56_pattern.table_currency'), //tiền tệ 
            binding: 'currency',
            minWidth: 140,
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            cssClassAll: 'required-field',
            dataMap: new DataMap(CURRENCY_TYPE),
            editor: new AutoComplete(document.createElement('div'), {
              placeholder: i18n.t('56_pattern.placeholder'),
              itemsSource: CURRENCY_TYPE,
              maxItems: 1000,
              minLength: 1,
              selectedIndex: -1,
            }),
          },
          {
            header: i18n.t('56_pattern.table_category1'), // hạng mục
            binding: 'category_2',
            minWidth: getWidthByTextContent(i18n.t('56_pattern.table_category1')),
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
          },
          {
            header: i18n.t('56_pattern.table_property_buy_value'), // giá trị khi mua
            binding: 'value_purchase',
            minWidth: getWidthByTextContent(i18n.t('56_pattern.table_property_buy_value'), 4),
            maxWidth: 980,
            allowSorting: false,
            isRequired: false,
            wordWrap: true,
            align: 'right',
            cssClassAll: 'required-field',
          },
        ],
      },
      {
        header: i18n.t('56_pattern.summary_score_dq_quality_score'), // default value -> pattern 42 => 2
        binding: 'dq_quality_score',
        minWidth: getWidthByTextContent(i18n.t('56_pattern.summary_score_dq_quality_score')),
        maxWidth: 980,
        allowSorting: false,
        isRequired: false,
        wordWrap: true,
        isReadOnly: true,
        align: 'right',
      },
      {
        header: i18n.t('56_pattern.table_emissions'),
        binding: 'emissions',
        cssClass: 'auto-increment',
        cssClassAll: 'emission',
        align: 'right',
        minWidth: 90,
        maxWidth: 980,
        allowSorting: false,
        isRequired: false,
        inputType: 'float',
        dataType: 'Number',
      },
      {
        header: i18n.t('56_pattern.table_attach_file'),
        binding: "attach_file",
        cssClass: 'auto-increment',
        minWidth: getWidthOfAttachedButton(i18n.locale),
        maxWidth: getWidthOfAttachedButton(i18n.locale),
        allowSorting: false,
        isRequired: false,
        cssClassAll: "btn-db attach-file hide-filter",
        cellTemplate: (ctx, el) => {
          let text = i18n.t('56_pattern.table_attach_file');
          if (ctx.item?.evidence) {
            text = `<div class="file-attached-container">
              <img src="${require('@/assets/icons/file_attached.svg')}" alt="file attached icon" class="file_attached">
            </div>`
          }
          const button = CellMaker.makeButton({
            text: text,
            click: (e, context) => attachFilePopup(e, context)
          })
          return button(ctx, el);
        }
      },
      {
        header: i18n.t('user_management.table_status'),
        binding: "status",
        minWidth: 100,
        width: 100,
        allowSorting: false,
        isRequired: false,
        wordWrap: true,
        cssClassAll: 'status-field',
      }
    ];
  },

  handlerDataOnTable(dataProps) {
    const {
      dataTable,
      bindingLayout,
      isSaveTemplate,
      branchData,
      isGetBranchDetail,
      dbStore,
      itemAdded,
      isLimitedAttributionFactor,
      isDeleteTingEvent,
      dbItem,
    } = dataProps

    if (!isDeleteTingEvent && !dataTable.isDeleteRow) {
      if (!dataTable?.dq_quality_score) {
        dataTable.dq_quality_score = 2;
      }
      if (!dataTable?.currency) {
        dataTable.currency = CURRENCY_TYPE[0]
      }
    }

    let databaseTypeObject = {};
    if (dataTable.idDbExternal && itemAdded && itemAdded?.type === 2) {
      databaseTypeObject = itemAdded
    } else {
      databaseTypeObject = dbItem || {};
      dataTable.idDbExternal = null
      dataTable.db_relation = null
    }

    if (!isGetBranchDetail) return
    const dataForCalcEmissions = {
      loan_amount: dataTable.loan_amount,
      value_purchase: dataTable.value_purchase,
      amount_of_fuel_consumed: dataTable.amount_of_fuel_consumed,
      fuel_intensity: dataTable.fuel_intensity,
      isLimitedAttributionFactor,
    }
    const emissions = calcEmissions(dataForCalcEmissions);

    const dataForCalcAmountOfFuelConsumed = {
      total_distance_driven: dataTable.total_distance_driven,
      fuel_consumption: dataTable.fuel_consumption,
    }

    const amount_of_fuel_consumed = calcAmountOfFuelConsumed(dataForCalcAmountOfFuelConsumed);

    const layoutsData = {}
    bindingLayout.forEach(key => {
      layoutsData[key] = dataTable[key] || null
    })
    const branchId = isGetBranchDetail ? getBranchId(branchData.filterPatternList, {
      organizational_division: dataTable.organizational_division,
      company_name: dataTable.company_name,
      ...layoutsData
    }) : {};

    if (typeof dataTable.evidence === 'string') {
      dataTable.evidence = JSON.parse(dataTable.evidence);
    }
    const fuelCode = dbStore.fuelList.find(item => item.fuel_code === parseInt(dataTable.fuel_type) || item.fuel_code === dataTable.fuel_type || item.value === dataTable.fuel_type)?.fuel_code;
    const basicUnitId = dbStore.basicUnitFuelList.find(item => item.fuel_intensity === dataTable.basic_unit_name || item.value === dataTable.basic_unit_name)?.basic_fuel_emission_factor_id;

    let dataTableItemCustom = {
      id: dataTable.id,
      company_name: dataTable.company_name || null,
      organizational_division: dataTable.organizational_division || null,
      emissions: formatEmission25Number(emissions),
      memo_1: dataTable.memo_1 || null,
      memo_2: dataTable.memo_2 || null,
      category_1: dataTable.category_1 || null,
      category_2: dataTable.category_2 || null,
      currency: dataTable.currency || null,
      loan_amount: isSaveTemplate ? '' : formatNumberBySetting(dataTable.loan_amount) === 0 ? '0' : formatNumberBySetting(dataTable.loan_amount) || null,
      value_purchase: isSaveTemplate ? '' : formatNumberBySetting(dataTable.value_purchase) === 0 ? '0' : formatNumberBySetting(dataTable.value_purchase) || null,
      contractor_id: store.state.userData.contractor, // from store
      month: dbStore.isFlagUpdateDataListEmission ? dataTable.month : store.state.registerData.month, // from store
      year: dbStore.isFlagUpdateDataListEmission ? dataTable.year : store.state.registerData.yearSelected,
      type: databaseTypeObject.type,
      dq_quality_score: dataTable.dq_quality_score || null,
      ...layoutsData,
      branch_id: branchId?.id || null,
      evidence: dataTable.evidence || null,
      status: dataTable.status ? 1 : 0,
      is_in_approx: isLimitedAttributionFactor ? 1 : 0,
      fuel_efficiency: formatNumberBySetting(dataTable.fuel_efficiency) === 0 ? '0' : formatNumberBySetting(dataTable.fuel_efficiency) || null,
      fuel_code: fuelCode || null,
      basic_fuel_emission_factor_id: basicUnitId || null,
      total_distance_driven: isSaveTemplate ? '' : formatNumberBySetting(dataTable.total_distance_driven) || null,
      amount_of_fuel_consumed: isSaveTemplate ? '' : amount_of_fuel_consumed === 0 ? '0' : amount_of_fuel_consumed || null,
      vehicle_type: dataTable.vehicle_type || null,
      car_model_efficiency_id: dataTable.car_model_efficiency_id || null
    };

    if (dataTable.evidence) {
      if (dataTable.is_primary_data) {
        delete dataTable.evidence.value;
      }
      else {
        dataTableItemCustom.evidence.value = dataTable[this.bindingValueColumn];
      }
    }

    if (dataTableItemCustom.type > 0) {
      dataTableItemCustom.db_customize_id = null
    }
    if (dataTableItemCustom.type === 2 || dataTable.idDbExternal) {
      dataTableItemCustom.db_relation = {
        db_source_detail_id: databaseTypeObject.origin_id
      }
      dataTableItemCustom.type = 2
      dataTableItemCustom.db_customize_id = null
    }

    return dataTableItemCustom;
  },
  addBlankItemsToView: (view, count) => {
    const lastClientId = view.itemCount
    for (let index = 1; index <= count; index++) {
      view.addNew(blankData(lastClientId + index));
    }

    view.commitNew();
  },

  filterColumns: [ //todo: update or remove
    'organizational_division',
    'company_name',
    'business_name',
    'ides_name_company',
    'scale_index_source',
    'scale_index_unit',
    'wsu_unit',
    'wsu_source',
  ],

  autoFields: [
    // 'emissions_factor',
    'ides_industry',
  ],

  getError(item, propName, dbStore, validateErrorBtn = {}, isRemoveEmissionFactorOrValNumber) {
    const { itemsInView = [], branchData = [], isCheckMappingFacility = false, itemsInViewError = [] } = validateErrorBtn;
    const verifyItemKey = !isRemoveEmissionFactorOrValNumber ? notNullListIncludeValueNumber2 : notNullList
    if (verifyItemKey.includes(propName)) {
      if (item[propName] === null || item[propName] === '' || item[propName] === undefined || !item[propName] && item[propName] !== 0) {
        return MESSAGE_NOT_NULL;
      }
    }

    if (numberField.includes(propName)) {
      if (!item[propName] && item[propName] !== 0) {
        return MESSAGE_NOT_NULL
      } else {
        return validateNumberFieldBySetting(String(item[propName]), propName);
      }
    }

    if (max25Charactor.includes(propName)) {
      if (numberField.includes(propName)) {
        return validateNumberFieldBySetting(String(item[propName]), propName);
      }
      return validateMaximumCharactorOnlyFacility(String(item[propName]), 20);
    }

    if (max128Charactor.includes(propName)) {
      return validateMaximumCharactorOnlyFacility(String(item[propName]), 128);
    }

    if (isCheckMappingFacility && filterColumns.includes(propName)) {
      const layoutsData = {}
      itemsInView.forEach(key => {
        layoutsData[key] = item[key] || null
      })
      const branchId = getBranchId(branchData.filterPatternList, {
        organizational_division: item.organizational_division,
        company_name: item.company_name,
        ...layoutsData
      });

      if (!branchId) {
        return i18n.t('new_validate.error_mapping_layer', { listLayer: itemsInViewError.map(item => item)?.join('/') })
      }
    }
    return null
  },

  cellInputInView(bindingLayout) {
    return [
      'organizational_division',
      'company_name',
      'memo_1',
      'memo_2',
      'loan_amount',
      'category_1',
      'category_2',
      'value_purchase',
      'attach_file',
      'currency',
      'dq_quality_score',
      'car_model_identifier',
      'fuel_efficiency',
      'fuel_consumption',
      'fuel_type',
      'basic_unit_name',
      'fuel_intensity',
      'total_distance_driven',
      'amount_of_fuel_consumed',
      'vehicle_type',
      ...bindingLayout
    ];
  },

  cellRequireInView(bindingLayout) {
    return [
      'organizational_division',
      'company_name',
      'memo_1',
      'memo_2',
      'loan_amount',
      'category_1',
      'category_2',
      'value_purchase',
      'attach_file',
      'currency',
      'car_model_identifier',
      'fuel_efficiency',
      'fuel_consumption',
      'fuel_type',
      'basic_unit_name',
      'fuel_intensity',
      'total_distance_driven',
      'fuel_efficiency',
      'fuel_consumption',
      'vehicle_type',
      ...bindingLayout
    ];
  },
  patternUrl: '/pattern-s3-c15/10',
  bindingValueColumn: 'total_distance_driven',

  calcEmissions(rowData) {
    return calcEmissions(rowData)
  },

  getQualityScore(typeData, items) {
    return getScoreByType(typeData, items)[0];
  },

  calcAmountOfFuelConsumed(rowData) {
    return calcAmountOfFuelConsumed(rowData)
  },

  setFilterIndex(filterIndexValue) {
    filterIndex = filterIndexValue;
  },
  updateFilterIndex(filterIndexValue) {
    filterIndex = { ...filterIndex, ...filterIndexValue }
  },
  isUseBasicUnit: true,
  getAutoBindingDbSource(dataProps) {
    return autoBindingDbSource(dataProps);
  }
};
export default parternS3c15pcaf6;
